<div class="py-7">
    <h4 class="">Préférences</h4>
    <p class="text-sm text-gray-600 mb-4">Configurez vos préférences de compte ici.</p>

    <div class="rounded-lg border border-gray-200 bg-white p-4">
        <h5 class="font-medium mb-3">Notifications</h5>
        <div class="space-y-3">
            <label class="flex items-center gap-3 cursor-pointer">
                <input type="checkbox" class="toggle toggle-primary" [(ngModel)]="notificationSms">
                <div>
                    <div class="text-sm font-medium">SMS</div>
                    <div class="text-xs text-gray-500">Recevoir des notifications par SMS</div>
                </div>
            </label>
            <!-- Push -->
            <label class="flex items-center gap-3 cursor-pointer">
                <input
                    type="checkbox"
                    class="toggle toggle-primary"
                    [(ngModel)]="notificationPush"
                    (ngModelChange)="onPushPreferenceChange($event)"
                    [disabled]="pushProcessing || saving">
                <div>
                    <div class="text-sm font-medium">
                        Push
                        <span class="loading loading-spinner loading-xs ml-1" *ngIf="pushProcessing"></span>
                    </div>
                    <div class="text-xs text-gray-500">Recevoir des notifications push</div>
                </div>
            </label>
            <label class="flex items-center gap-3 cursor-pointer">
                <input type="checkbox" class="toggle toggle-primary" [(ngModel)]="notificationEmail">
                <div>
                    <div class="text-sm font-medium">Email</div>
                    <div class="text-xs text-gray-500">Recevoir des notifications par email</div>
                </div>
            </label>
        </div>
    </div>
    <div class="mt-4 flex justify-end">
        <button class="btn btn-primary btn-sm" (click)="savePreferences()" [disabled]="saving">
            <span class="loading loading-spinner loading-xs" *ngIf="saving"></span>
            <span *ngIf="!saving">Enregistrer</span>
        </button>
    </div>
</div>
